import { actionGenerator } from "./../../Utils/createAuxilaryActions"

export const scheduleAppointmentConsts = {
    SELECT_MENTOR: 'SA/SELECT_MENTOR',
    GET_AVAILABLE_SLOTS:'SA/GET_AVAILABLE_SLOTS',
    GET_AVAILABLE_SLOTS_SUCCESS:'SA/GET_AVAILABLE_SLOTS_SUCCESS',
    GET_AVAILABLE_SLOTS_FAILURE:'SA/GET_AVAILABLE_SLOTS_FAILURE',
    SELECT_TIME_SLOT:'SA/SELECT_TIME_SLOT',
    SELECT_IS_GROUP:'SA/SELECT_IS_GROUP',
    SELECT_ATTENDEES:'SA/SELECT_ATTENDEES',
    ADD_REQUEST_MESSEGE: 'SA/REQUEST_MESSEGE',
    CONIRM_APPOINTMENT:  'SA/CONIRM_APPOINTMENT',
    GET_INVOICE_DETAILS:  'SA/GET_INVOICE_DETAILS',
    GET_INVOICE_DETAILS_SUCCESS:  'SA/GET_INVOICE_DETAILS_SUCCESS',
    GET_INVOICE_DETAILS_FAILURE:  'SA/GET_INVOICE_DETAILS_FAILURE',
    MAKE_PAYMENT:  'SA/MAKE_PAYMENT',
    MAKE_PAYMENT_SUCCESS:  'SA/MAKE_PAYMENT_SUCCESS',
    MAKE_PAYMENT_FAILURE:  'SA/MAKE_PAYMENT_FAILURE',
}


const [
    selectMentor,
    getAvailableSlots,
    getAvailableSlotSuccess,
    getAvailableSlotFailure, 
    selectTimeSlot, 
    selectIsGroup,
    selectAttendees, 
    addRequestMessage,
    confirmAppointment, 
    getInvoiceDetails,
    getInvoiceDetailsSuccess,
    getInvoiceDetailsFailure,
    makePayment,
    makePaymentSuccess,
    makePaymentFailure 
] = actionGenerator(Object.values(scheduleAppointmentConsts))

export {selectMentor,getAvailableSlots,getAvailableSlotSuccess,getAvailableSlotFailure, selectTimeSlot, selectIsGroup,selectAttendees,addRequestMessage, confirmAppointment, getInvoiceDetails,getInvoiceDetailsSuccess,getInvoiceDetailsFailure,makePayment,makePaymentSuccess,makePaymentFailure }

